<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div class="relative w-full max-w-2xl bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 p-6 md:p-8 animate-fade-in-up max-h-[90vh] overflow-y-auto">
    <div *ngIf="isLoading()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex items-center justify-between mb-6 pb-4 border-b border-slate-100 dark:border-slate-800">
      <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">payments</span>
        {{ formData.id ? 'แก้ไขค่าธรรมเนียม' : 'เพิ่มค่าธรรมเนียม' }}
      </h3>
      <button (click)="onClose()" class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-50 transition-colors">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="md:col-span-2">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อรายการ <span class="text-rose-500">*</span></label>
        <input type="text" [(ngModel)]="formData.name" class="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm">
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Fee Master <span class="text-rose-500">*</span></label>
        <select [(ngModel)]="formData.feeId" (ngModelChange)="onFeeMasterChange()" class="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm">
          <option [ngValue]="0">-- เลือก --</option>
          <option *ngFor="let fee of feeMasters" [ngValue]="fee.id">{{ fee.name }}</option>
        </select>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ประเภทรายรับ <span class="text-rose-500">*</span></label>
        <select [(ngModel)]="formData.feeTypeId" class="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm">
          <option [ngValue]="null">-- เลือก --</option>
          <option *ngFor="let type of feeTypes" [ngValue]="type.id">{{ type.name }}</option>
        </select>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">จำนวนเงิน</label>
        <input type="number" [(ngModel)]="formData.fee" min="0" step="0.01" class="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm">
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ลำดับแสดงผล</label>
        <input type="number" [(ngModel)]="formData.sortOrder" min="0" class="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm">
      </div>

      <div class="md:col-span-2">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">รายละเอียด</label>
        <textarea [(ngModel)]="formData.description" rows="2" class="w-full px-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm"></textarea>
      </div>

      <div class="flex items-center gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800">
        <input type="checkbox" id="vat" [(ngModel)]="formData.vat" class="rounded text-amber-500">
        <label for="vat" class="text-sm font-medium text-slate-700 dark:text-slate-300">คิด VAT</label>
      </div>

      <div class="flex items-center gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800">
        <input type="checkbox" id="status" [(ngModel)]="formData.status" class="rounded text-emerald-500">
        <label for="status" class="text-sm font-medium text-slate-700 dark:text-slate-300">เปิดใช้งาน</label>
      </div>
    </div>

    <div class="flex items-center justify-between gap-3 mt-8 pt-4 border-t border-slate-100 dark:border-slate-800">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isLoading()"
        class="px-5 py-2.5 border border-slate-200 dark:border-slate-700 hover:border-amber-400 hover:text-amber-600 text-slate-600 dark:text-slate-300 font-bold rounded-xl shadow-sm transition-all inline-flex items-center gap-1.5 cursor-pointer disabled:opacity-50">
        <span class="material-icons text-base">history</span>
        ดูประวัติ
      </button>
      <div class="flex items-center justify-end gap-3 ml-auto">
        <button (click)="onClose()" class="px-5 py-2.5 bg-slate-50 dark:bg-slate-800 text-slate-500 font-bold rounded-xl">ยกเลิก</button>
        <button (click)="onSave()" class="px-6 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg">บันทึก</button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && formData.id"
  [entityType]="activityEntityTypes.InvoiceFee"
  [entityId]="formData.id!"
  title="ประวัติค่าธรรมเนียมใบแจ้งหนี้"
  [subtitle]="'#' + formData.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
